import React from 'react';
import { DropZone, createUsePuck } from '@puckeditor/core';
import { tabZoneKey, tabZoneName } from './tabsLayout';

const usePuckApi = createUsePuck();

/** Un onglet contient exactement un Bloc : rien d'autre n'y est déposable. */
const ONLY_SECTION = ['ProposalSection'];
/** allow=[] : Puck désactive nativement la zone pour le dnd (drop impossible). */
const BLOCK_ALL_TYPES = [];

/**
 * Occupation lue dans le store avec un sélecteur BOOLÉEN : la zone ne se
 * re-rend que sur la transition vide ↔ occupée, jamais pendant la frappe ni
 * pendant un glissement. Même montage que
 * `blocks/proposal/ProposalSection/SectionColumnDropZone.jsx`.
 */
function EditorTabDropZone({ blockId, tabId, ...dropZoneProps }) {
  const occupied = usePuckApi(
    (s) => (s.appState.data.zones?.[tabZoneKey(blockId, tabId)]?.length ?? 0) > 0,
  );
  return (
    <DropZone
      {...dropZoneProps}
      zone={tabZoneName(tabId)}
      allow={occupied ? BLOCK_ALL_TYPES : ONLY_SECTION}
    />
  );
}

/**
 * Zone de dépôt d'un onglet.
 * - Éditeur : n'accepte qu'un `ProposalSection`, et plus rien une fois occupée.
 * - Viewer (`<Render>`, hors contexte `<Puck>`) : DropZone simple — `usePuck`
 *   n'y existe pas.
 */
export default function TabPanelDropZone({ isEditing = false, blockId, tabId, ...dropZoneProps }) {
  if (!isEditing) {
    return <DropZone {...dropZoneProps} zone={tabZoneName(tabId)} />;
  }
  return <EditorTabDropZone blockId={blockId} tabId={tabId} {...dropZoneProps} />;
}
